import React from 'react';

const CalendarLineIcon = ({
  width = '15',
  height = '15',
  fill = 'none',
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 15 15"
    fill={fill}
    {...props}
  >
    <g opacity="0.5">
      <path
        d="M4.31348 1.13379V2.53379"
        stroke="black"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.3135 1.13379V2.53379"
        stroke="black"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.7035 13.323C13.441 13.5856 13.0849 13.7331 12.7137 13.7332H2.91367C2.54237 13.7332 2.18627 13.5857 1.92372 13.3232C1.66117 13.0606 1.51367 12.7045 1.51367 12.3332V3.9332C1.51367 3.5619 1.66117 3.2058 1.92372 2.94325C2.18627 2.6807 2.54237 2.5332 2.91367 2.5332H12.7137C13.085 2.5332 13.4411 2.6807 13.7036 2.94325C13.9662 3.2058 14.1137 3.5619 14.1137 3.9332V12.3332C14.1136 12.7045 13.966 13.0605 13.7035 13.323Z"
        stroke="black"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.68652 6.44922H10.9417"
        stroke="black"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.68652 9.81738H7.81412"
        stroke="black"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

export default CalendarLineIcon;
